import styled from "@emotion/styled";
import JeftinijeLogo from "src/assets/images/brands/jeftinije-white.svg";
import { i18n, isJeftinijeSource, mediaQueryMax } from "src/common";
import { colors } from "src/theme";

const JEFTINIJE_URL = 'https://www.jeftinije.hr';

const BannerStyle = styled.a({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '8px',
  width: '100%',
  padding: '10px 16px',
  borderRadius: '8px',
  backgroundColor: '#3B8DEE',
  color: colors.white,
  fontSize: '16px',
  lineHeight: '24px',
  textAlign: 'center',
  textDecoration: 'none',
  cursor: 'pointer',
  transition: 'opacity 0.2s',

  '&:hover': {
    opacity: 0.85,
  },

  [mediaQueryMax('mobile')]: {
    fontSize: '14px',
    lineHeight: '20px',
    gap: '6px',
  },
});

const LogoStyle = styled.img({
  height: '26px',
  display: 'block',

  [mediaQueryMax('mobile')]: {
    height: '20px',
  },
});

interface PartnerBannerProps {
  source?: string | null;
  className?: string;
}

export const PartnerBanner = ({ source, className }: PartnerBannerProps) => {
  if (!isJeftinijeSource(source)) return null;

  return (
    <BannerStyle
      className={className}
      href={JEFTINIJE_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span>{i18n.t('components.partnerBanner.jeftinije.prefix')}</span>
      <LogoStyle src={JeftinijeLogo} alt="jeftinije!" />
      <span>{i18n.t('components.partnerBanner.jeftinije.suffix')}</span>
    </BannerStyle>
  );
};
